export default __webpack_public_path__ + "static/media/BM_RenderCamera_22_CU_C+Interior+Detail+Bathroom.f02fba9e.jpg";